export const projects = [
  {
    name: "Forge – AI Learning Assistant",
    demo: "https://forge-zeta.vercel.app/",
    github: "https://github.com/Chakit22/forge",
    image: "./assets/forge.png",
    description:
      "AI-powered tool with smart summaries, quizzes, mindmaps (React Flow), and speech-to-text notes. Built with Next.js, GPT-4o, Weaviate, and Whisper.",
    featured: true,
  },
  {
    name: "Paper Trading App",
    demo: "https://stocks-chakit22-3-ehog.vercel.app/",
    github: "https://github.com/mac-projects-assessment/stocks-Chakit22-3",
    image: "./assets/paper-trading-app.png",
  },
  {
    name: "Portfolio",
    demo: "https://tasky-eta-teal.vercel.app/",
    github: "https://github.com/ChakitBhandari/Portfolio",
    image: "./assets/portfolio.png",
  },
  {
    name: "To Do List",
    demo: "https://tasky-eta-teal.vercel.app/",
    github: "https://github.com/Chakit22/Tasky",
    image: "./assets/tasky.png",
  },
  {
    name: "Simon Game",
    demo: "https://phenomenal-alpaca-9ad355.netlify.app/",
    github: "https://github.com/ChakitBhandari/Simon-Game",
    image: "./assets/simon-game.png",
  },
  {
    name: "Dice Game",
    demo: "https://fantastic-muffin-018955.netlify.app/",
    github: "https://github.com/ChakitBhandari/Dice-Game",
    image: "./assets/dice-game.png",
  },
  {
    name: "Binge Watch",
    demo: "https://bingewatch-ff180.web.app/",
    github: "https://github.com/ChakitBhandari/BingeWatch",
    image: "./assets/binge-watch.png",
  },
  {
    name: "Library Management System",
    demo: undefined,
    github: "https://github.com/Chakit22/Library-Management",
    image: "./assets/library-management-system.png",
  },
  {
    name: "Product Landing Page",
    demo: undefined,
    github: "https://github.com/Chakit22/product-landing-page",
    image: "./assets/product-landing-page.png",
  },
  {
    name: "Blog Website",
    demo: undefined,
    github: "https://github.com/Chakit22/Blog_Website",
    image: undefined,
  },
  // {
  //   name: "Weather App",
  //   demo: "https://weather-application-roan-gamma.vercel.app/",
  //   github: "https://github.com/Chakit22/Weather_Application",
  //   image: "./assets/weather-app.png",
  // },
];
